import React from "react";
import { connect } from "react-redux";
import {
  DetailsList,
  Spinner,
  SpinnerSize,
  Dialog,
  DialogFooter,
  CheckboxVisibility,
  TextField,
  TagPicker,
  DefaultButton,
} from "office-ui-fabric-react";
import * as axios from "../axios/users";
import StatusBar from "./common/StatusBar";
import _ from "lodash";

export class ZipCodeAssignment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDialog: false,
      isLoading: false,
      showDialogDelete: false,
      showComments: false,
      showReminderDate: false,
      columns: columns,
      data: {},
    };
  }

  componentDidMount() {
    this.props.dispatch(axios.list());
  }

  close() {
    this.setState({
      showDialog: false,
      data: {},
    });
  }

  save() {
    var manager = this.state.data;
    var users = this.props.users.data || [];
    var staffs = this.refs.staffs.items;

    var currectStaffs = users.filter((e) => e.managerId == manager._id);

    var removeStaffs = currectStaffs.filter(
      (e) => !_.find(staffs, (s) => s.key == e._id)
    );

    staffs.forEach((e) => {
      this.props.dispatch(
        axios.update({
          _id: e.key,
          managerId: this.state.data._id,
        })
      );
    });

    removeStaffs.forEach((e) => {
      this.props.dispatch(
        axios.update({
          _id: e._id,
          managerId: null,
        })
      );
    });

    this.setState({
      isLoading: true,
    });
    setTimeout(() => {
      this.setState({
        showDialog: false,
        isLoading: false,
      });
      this.rowSelected = null;
      this.selected = null;
    }, staffs.length * 200);
  }

  show(e) {
    this.rowSelected = e;
    this.setState({
      showDialog: true,
      data: e,
    });
  }

  valueChange(key, v) {
    this.rowSelected[key] = v;
  }

  _onFilterChanged(filterText, tags) {
    var users = this.props.users.data || [];
    var manager = this.state.data;
    if ("" == filterText.trim()) {
      return users
        .filter((e) => e.accountType == "staff")
        .filter((e) => e.managerId == manager._id || !e.managerId)
        .filter((e) => !_.find(tags, (t) => t.key == e._id))
        .map((e) => ({
          key: e._id,
          name: `${e.fname} ${e.lname} (${e.email})`,
        }))
        .slice(0, 10);
    }
    var result = users
      .filter((e) => e.accountType == "staff")
      .filter((e) => e.managerId == manager._id || !e.managerId)
      .filter((e) => !_.find(tags, (t) => t.key == e._id))
      .filter(
        (e) =>
          `${e.fname} ${e.lname} (${e.email})`
            .toLowerCase()
            .indexOf(filterText.toLowerCase()) >= 0
      )
      .map((e) => ({
        key: e._id,
        name: `${e.fname} ${e.lname} (${e.email})`,
      }));
    return result;
  }

  render() {
    var columns = this.state.columns;
    var users = this.props.users;
    if (this.props.auth.user.accountType == "admin") {
      var processCollum = columns.find((e) => e.key == "action");
      processCollum.onRender = (e) => {
        return (
          <div>
            <button className="tbl-btn" onClick={() => this.show(e)}>
              <i className="ms-Icon ms-Icon--Edit" aria-hidden="true"></i>
            </button>
          </div>
        );
      };
    } else {
      columns = columns.filter((e) => e.key != "action");
    }

    return (
      <div style={{ margin: 10 }}>
        {users.error ? (
          <div className="ms-fontColor-red">Error</div>
        ) : !users.data ? (
          <Spinner size={SpinnerSize.large} />
        ) : (
          <div style={{ marginBottom: 30 }}>
            <DetailsList
              items={users.data
                .filter((e) => e.accountType == "manager")
                .map((e) => {
                  e.listStaffs = users.data.filter(
                    (staff) => staff.managerId == e._id
                  );
                  e.totalStaffs = e.listStaffs.length;

                  return e;
                })}
              columns={columns}
              checkboxVisibility={CheckboxVisibility.hidden}
              style={{ fontSize: 14 }}
            />
            <StatusBar>
              <span>Total: {users.data.length}</span>
              {this.state.data._id && (
                <span>
                  {" "}
                  | Selected: #{users.data.indexOf(this.state.data) + 1} -{" "}
                  {`${this.state.data.fname} ${this.state.data.lname}`}{" "}
                </span>
              )}
            </StatusBar>
          </div>
        )}
        {this.state.data._id && (
          <Dialog
            isOpen={this.state.showDialog}
            title="Add Staff to Management"
            isBlocking={false}
            closeButtonAriaLabel="Close"
            containerClassName="info-list-modal"
            onDismiss={() => this.close()}
          >
            <div className="ms-Grid">
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-u-md12">
                  <TextField
                    label="Name"
                    value={this.state.data.fname + " " + this.state.data.lname}
                    disabled={true}
                  />
                </div>
                <div className="ms-Grid-col ms-u-md12">
                  <TextField
                    label="Email"
                    value={this.state.data.email}
                    disabled={true}
                  />
                </div>
                <div className="ms-Grid-col ms-u-md12">Staffs</div>
                <div className="ms-Grid-col ms-u-md12 zipcode-assignment-tag-picker">
                  <TagPicker
                    ref="staffs"
                    pickerSuggestionsProps={{
                      suggestionsHeaderText: "Staff",
                      noResultsFoundText: "No staff Found",
                    }}
                    onResolveSuggestions={this._onFilterChanged.bind(this)}
                    getTextFromItem={(item) => {
                      return item.name;
                    }}
                    defaultSelectedItems={users.data
                      .filter((e) => e.managerId == this.state.data._id)
                      .map((e) => ({
                        key: e._id,
                        name: `${e.fname} ${e.lname} (${e.email})`,
                      }))}
                  />
                </div>
              </div>
            </div>
            <DialogFooter>
              <PrimaryButton onClick={() => this.save()}>
                {this.state.isLoading ? (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Spinner size={SpinnerSize.xSmall} />
                    &nbsp; Saving
                  </div>
                ) : (
                  <span>Save</span>
                )}
              </PrimaryButton>
              <DefaultButton onClick={() => this.close()}>Cancel</DefaultButton>
            </DialogFooter>
          </Dialog>
        )}
      </div>
    );
  }
}

export default connect((state) => ({
  auth: state.auth,
  users: state.users,
  customer: state.customer,
}))(ZipCodeAssignment);

const columns = [
  {
    key: "fname",
    name: "First name",
    fieldName: "fname",
    minWidth: 50,
    maxWidth: 120,
  },
  {
    key: "lname",
    name: "Last name",
    fieldName: "lname",
    minWidth: 50,
    maxWidth: 120,
  },
  {
    key: "email",
    name: "Email address",
    fieldName: "email",
    minWidth: 250,
    maxWidth: 250,
  },
  {
    key: "role",
    name: "Role",
    fieldName: "accountType",
    minWidth: 80,
    maxWidth: 80,
  },
  {
    key: "listStaffs",
    name: "List staffs",
    fieldName: "listStaffs",
    isMultiline: true,
    onRender: (item) => {
      return item.listStaffs.map((e) => (
        <div key={e._id}>{`${e.fname} ${e.lname} (${e.email})`}</div>
      ));
    },
  },
  {
    key: "totalStaffs",
    name: "Total Staffs",
    fieldName: "totalStaffs",
    minWidth: 70,
    maxWidth: 70,
  },
  {
    key: "action",
    name: "",
    fieldName: "action",
    minWidth: 80,
    maxWidth: 80,
  },
];



// WEBPACK FOOTER //
// ./client/components/AssignStaff.js